import type { Building } from "building-types/building/buildingTypes";
import { getSourceRoomId } from "building-types/components/componentInstanceUtils";
import type { Doc } from "building-types/doc";
import type { TargetedPorchSettings } from "building-types/porches/porch";
import { RoomType } from "building-types/rooms/roomTypesEnum";
import type { PorchSettingsBase } from "building-types/settings/porchSettingsTypes";
import { mergeSettingsForEntity } from "doc/mergeSettingsSet";

export default function getTargetedPorchSettings(
  building: Pick<Building, "settingsSets" | "optionChoices" | "settings" | "rooms">,
  doc: Pick<Doc, "settings" | "entitySettings">,
): TargetedPorchSettings {
  const { settingsSets, optionChoices, settings: finalHomeSettings } = building;
  const { settings, entitySettings } = doc;

  const targetedPorchSettingsTable: { [porchId: string]: PorchSettingsBase } = {};

  for (const id in building.rooms) {
    const room = building.rooms[id];
    if (room.type !== RoomType.FRONT_PORCH && room.type !== RoomType.REAR_PORCH) {
      continue;
    }
    const roomId = getSourceRoomId(room);

    const hasEntitySettings = Object.values(entitySettings).some((entitySetting) => entitySetting.entityId === roomId);
    if (!hasEntitySettings) {
      continue;
    }

    const roomEntitySettings = mergeSettingsForEntity(entitySettings, roomId, settingsSets, settings, optionChoices);

    if (room.type === RoomType.FRONT_PORCH) {
      Object.assign(targetedPorchSettingsTable, {
        [roomId]: { ...finalHomeSettings.porch, ...roomEntitySettings.porch },
      });
    } else {
      Object.assign(targetedPorchSettingsTable, {
        [roomId]: { ...finalHomeSettings.rearPorch, ...roomEntitySettings.rearPorch },
      });
    }
  }

  return targetedPorchSettingsTable;
}
